import { RepresentanteFilter } from './representante-filter';

export class RepresentanteFilterStorage {
    filter: RepresentanteFilter;
    filterValues: Map<string, any>;

    constructor(filter: RepresentanteFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
